import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";

import { SearchFilter } from "../../../common/components/functional/FilterSearchField/FilterSearchField";
import {
  buildInvoiceFilters,
  InvoiceFilterFormTypes,
  parseInvoiceFilters,
} from "./common";
import FiltersForm from "./FiltersForm";

interface Props {
  filters: SearchFilter[];
  updateFilters: (filters: SearchFilter[]) => void;
  handleMenuToggle: () => void;
}

export const InvoiceFilters = ({
  filters,
  updateFilters,
  handleMenuToggle,
}: Props) => {
  // The initial values are needed on the first render, because FiltersForm
  // uses them to start the customer organization and cost center searches
  const methods = useForm<InvoiceFilterFormTypes>({
    defaultValues: parseInvoiceFilters(filters),
    mode: "onChange",
  });
  const { reset, getValues } = methods;

  // Pass incoming filter values to the form
  useEffect(() => {
    reset(parseInvoiceFilters(filters));
  }, [filters, reset]);

  // Not using handleSubmit on purpose: the 'required' rules in FiltersForm
  // have never blocked searching
  const sendFilters = () => {
    handleMenuToggle();
    updateFilters(buildInvoiceFilters(getValues()));
  };

  return (
    <FormProvider {...methods}>
      <FiltersForm sendFilters={sendFilters} />
    </FormProvider>
  );
};
